import { createContext } from "react";

export const SortableContext = createContext();
